export function range(start, stop, step = 1) {
  const vals = [];
  for (let i = start; i <= stop; i += step) {
    vals.push(i);
  }
  return vals;
}

export function intersection(set1, set2) {
  const result = new Set();
  for (const element of set1) {
    if (set2.has(element)) {
      result.add(element);
    }
  }
  return result;
}

export function populateObjectWithDefaults(object, defaults) {
  for (let [key, val] of Object.entries(defaults)) {
    if (object[key] === undefined) {
      object[key] = val;
    }
  }
}

export function sum(iterable) {
  return Array.from(iterable).reduce((prev, curr) => prev + curr, 0);
}
